import wx from 'weixin-js-sdk';
import axios from 'axios';
import {urlConfig} from '@/api/urlConfig.js';

function isWeiXin(){
  var ua = window.navigator.userAgent.toLowerCase();
  if(!(ua.match(/MicroMessenger/i) == 'micromessenger')){
    document.getElementsByTagName('body')[0].innerHTML = '请在微信浏览器打开';
  }
}
function hideXWMenu(openid) {
  var _this = this;
  axios.get(urlConfig.getsigninfo + encodeURIComponent(window.location.href)+'&openid='+openid
  ).then(response => {
    wx.config({
      debug: false,
      appId: response.data.appId,
      timestamp:response.data.timestamp,
      nonceStr: response.data.noncestr,
      signature: response.data.signature,
      jsApiList: ['hideMenuItems', 'showMenuItems']
    });
    wx.ready(function () {

      wx.hideOptionMenu();

    });
  }).catch(function (error) {
    alert('获取appid失败: ' +error);

  })

}
export {hideXWMenu,isWeiXin}



// WEBPACK FOOTER //
// ./src/api/showWXmenu.js